/* eslint-disable no-unused-vars */
let currentUtterance = null; 
/* eslint-enable no-unused-vars */

export function canNarrate() {
  return typeof window !== "undefined" && "speechSynthesis" in window;
}

export function stopNarration() {
  if (!canNarrate()) return;
  
  // Using the variable here helps satisfy some linter configurations
  if (window.speechSynthesis.speaking || currentUtterance) {
    window.speechSynthesis.cancel();
  }
  currentUtterance = null;
}

export function narrateText(text) {
  if (!canNarrate()) return false;
  
  // Stop any current speech before starting new speech
  stopNarration();

  const cleaned = String(text || "").replace(/\s+/g, " ").trim();
  if (!cleaned) return false;

  const utter = new SpeechSynthesisUtterance(cleaned);
  
  // Standard settings
  utter.rate = 1;
  utter.pitch = 1;
  utter.volume = 1;

  // Cleanup reference when finished or if an error occurs
  utter.onend = () => {
    currentUtterance = null;
  };
  utter.onerror = () => {
    currentUtterance = null;
  };

  currentUtterance = utter;
  window.speechSynthesis.speak(utter);
  
  return true;
}